import React, { useContext, useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

import { Subject } from "rxjs/internal/Subject";
import { distinctUntilChanged, map } from "rxjs/operators";
import { FormContext } from "./FormContext";
import { IFormState } from "./formInterfaces";
import { Button } from "../inputs/Button";

type Props = {
  label: string;
};

const useStyles = makeStyles(() => ({
  submitButton: {
    marginRight: "1em"
  }
}));

export const SubmitButton: React.FC<Props> = props => {
  const classes = useStyles(props);
  const { subscribe } = useContext(FormContext);
  const [submitPending, setSubmitPending] = useState(false);
  const [formComplete, setFormCompleted] = useState(false);
  const [formChanged, setFormChanged] = useState(false);

  useEffect(() => {
    const formStateObserver$ = new Subject<IFormState>();

    formStateObserver$
      .pipe(
        map(({ meta }) => meta),
        distinctUntilChanged(
          (next, prev) =>
            next.submitting === prev.submitting &&
            next.completed === prev.completed &&
            next.changed === prev.changed
        )
      )
      .subscribe(({ submitting, completed, changed }) => {
        setSubmitPending(submitting);
        setFormCompleted(completed);
        setFormChanged(changed);
      });

    const formStateSubscription = subscribe(formStateObserver$);

    return () => {
      formStateSubscription.unsubscribe();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Button
      className={classes.submitButton}
      color="primary"
      disabled={!formComplete || !formChanged || submitPending}
      id="submit"
      type="submit"
    >
      {submitPending ? (
        <>
          <CircularProgress color="inherit" size={18} />
          Submitting...
        </>
      ) : (
        props.label
      )}
    </Button>
  );
};
